import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FileConverter {

  convertBlobToDataUrl(data: Blob): Promise<string> {
    return new Promise<string>(resolve => {
      const reader = new FileReader();

      reader.onload = () => resolve(reader.result as string);
      reader.readAsDataURL(data);
    });
  }

  fileToFormData(file: File | Blob) {
    const formData = new FormData();
    formData.append('file', file);
    return formData;
  }

  dataURItoBlob(dataURI): Blob {
    // convert base64 to raw binary data held in a string
    const byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }
}
